import { makeActionCreator } from '../../config/store/utils';
import { batch } from 'react-redux';
import { getCsv } from '../../services/security';
import { getKeplerData, getKeplerUrl } from '../../services/keplerService';

export const GET_CYCLE = 'GET_CYCLE';
export const GET_CYCLE_ERROR = 'GET_CYCLE_ERROR';
export const GET_CYCLE_SUCCESS = 'GET_CYCLE_SUCCESS';
export const onGetMapbox = makeActionCreator(GET_CYCLE);
export const onGetMapboxError = makeActionCreator(GET_CYCLE_ERROR, 'payload');
export const onGetMapboxSuccess = makeActionCreator(
  GET_CYCLE_SUCCESS,
  'payload'
);
export const GET_PROGRESS = 'GET_PROGRESS';
export const onProgress = makeActionCreator(GET_PROGRESS, 'payload');

// Modify the thunk
export const onGetMapboxThunk = date => async (dispatch, getState) => {
  dispatch(onGetMapbox());

  try {
    let endpointParams = {};
    if (date) {
      endpointParams = {
        day: date[0].getDate(),
        month: date[0].getMonth() + 1,
        year: date[0].getFullYear(),
      };
    }

    const { url } = await getKeplerData(endpointParams);

    if (url.message === 'No data available for this day.') {
      return batch(() => {
        dispatch(onGetMapboxSuccess({ cycleData: [] }));
      });
    }
    const { data: rows } = await getKeplerUrl({
      url: url.downloadUrl,
      onProgress: (percent, loaded, total) => {
        dispatch(onProgress({ percent, loaded, total }));
      },
    });

    return batch(() => {
      dispatch(onGetMapboxSuccess({ cycleData: rows }));
    });
  } catch (error) {
    console.log(error);
    return dispatch(onGetMapboxError({ error }));
  }
};
